


define('jsx!components/shared/loading-button',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"jsx!components/shared/loading-indicator"
	],
	function($,_,Backbone,React, LoadingIndicator) {
		return React.createClass({
			loadingState: {
				LOADING: "loading",
				COMPLETE: "complete",
				INITIAL: "initial"
			},
			getInitialState: function () {
				return {
					loading: this.loadingState.INITIAL
				}
			},
			componentWillUpdate: function (nextProps, nextState) {
				var self = this;
				if(!this.props.loading && nextProps.loading) {
					nextState.loading = this.loadingState.LOADING;
				} else if(this.props.loading && !nextProps.loading) {
					nextState.loading = this.loadingState.COMPLETE;
					window.setTimeout(function() {
						self.setState({
							loading: self.state.INITIAL
						})
					}, 1500);
				}
			},
			render:function() {var $__0;
				var classNames = ["button-type-a", "btn-loader"];
				if(this.props.className) {
					($__0 = classNames).push.apply($__0, this.props.className);
				}
				if(this.state.loading === this.loadingState.LOADING) {
					classNames.push("loading");
				} else if(this.state.loading === this.loadingState.COMPLETE) {
					classNames.push("load-complete");
				}
				return(
					React.createElement("button", {
						id: this.props.id, 
						className: classNames.join(' '), 
						onClick: this.props.onClick, 
						onTouchEnd: this.props.onClick, 
						style: this.props.style || {}
						// disabled={ this.props.disabled }
					}, 
						React.createElement("span", {className: "text"}, this.props.text), 
						React.createElement(LoadingIndicator, null), 
						React.createElement("div", {className: "checkmark"})
					)
				)
			}
		});
	}
);
